import type { UserLookup } from '@models/user'
import type { UserFilters } from '@models/user'
import type { AxiosError } from 'axios'
import { useQuery } from 'react-query'
import usersApi from './actions'
import { usersKeys } from './constants'

interface UseUsersLookupData {
  users: UserLookup[]
  usersMap: Map<number, UserLookup>
}

export const selectData = (data: UserLookup[]): UseUsersLookupData => ({
  users: data,
  usersMap: new Map(data.map(userLookup => [userLookup.id, userLookup])),
})

export const useUsersLookup = (filters: UserFilters) => {
  const query = useQuery<UserLookup[], AxiosError, UseUsersLookupData>(
    usersKeys.usersLookup(filters),
    () => usersApi.getUsersLookup(filters),
    {
      enabled: !!filters?.companyId,
      select: selectData,
    },
  )

  return query
}

export default useUsersLookup
